"use strict";
/**
 * @module Protocol
 */
Object.defineProperty(exports, "__esModule", { value: true });
var consts_1 = require("./../protocol/consts");
/**
 * Create a connection request with provided options
 */
function connect() {
    return {
        type: consts_1.PROTOCOL.TYPE,
        version: consts_1.PROTOCOL.CURRENT_VERSION,
        capabilities: consts_1.PROTOCOL.CAPABILITIES
    };
}
exports.connect = connect;
/**
 * Create a reconnection request with provided options
 *
 * @param  token                    the session token
 * @param  availableClientSequence  the available client sequence number
 * @param  lastServerSequence       the last server sequence number
 * @return                          a new reconnection request
 */
function reconnect(token, availableClientSequence, lastServerSequence) {
    return Object.assign(connect(), {
        token: token,
        availableClientSequence: availableClientSequence,
        lastServerSequence: lastServerSequence
    });
}
exports.reconnect = reconnect;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/protocol/connection-request.js
// module id = 1868
// module chunks = 1